import { ReactComponent as CloseIcon } from '../../assets/images/close-icon.svg';
import { ReactComponent as InfoIcon } from '../../assets/images/info-icon.svg';

interface AgentOutdatedBannerProps {
  open: boolean;
  onClose: () => void;
  onCreateNewAgent: () => void;
}

const AgentOutdatedBanner = ({
  open,
  onClose,
  onCreateNewAgent,
}: AgentOutdatedBannerProps) => {
  if (!open) {
    return null;
  }

  return (
    <div className="mb-1 rounded-2xl border border-[#27AE60]/20 rounded-xl shadow-[0_8px_32px_rgba(0,0,0,0.4)] bg-[#1a2332] backdrop-blur-xl overflow-hidden">
      <div className="relative p-3 sm:p-3.5">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-3 top-3 text-white/40 hover:text-white/80 transition-colors"
          aria-label="Close outdated agent banner"
        >
          <CloseIcon width="12" height="12" />
        </button>

        <div>
          <div className="flex items-center gap-2">
            <InfoIcon className="h-3.5 w-3.5 text-[#27AE60] flex-shrink-0" />
            <h3 className="text-[#27AE60] font-semibold text-[14px] sm:text-[15px] leading-5">
              New agent version available
            </h3>
          </div>
          <p className="mt-2 text-[12px] text-white/70 leading-[18px]">
            A newer version is available. Create a new agent to use the latest features and improvements.
          </p>
        </div>

        <div className="mt-2.5 flex justify-end">
          <button
            type="button"
            style={{
              backgroundColor: '#27AE60',
            }}
            onClick={onCreateNewAgent}
            className="px-3 py-1.5 rounded-md text-white text-[13px] font-medium transition-colors bg-[#27AE60] hover:bg-[#1B75C9]"
          >
            Create new agent
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgentOutdatedBanner;
